<template>
  <div class="sidebar bool-card">
    <header>

      <router-link v-if="url" :to="{path: url}" class="concealed-link">{{ title }}</router-link>
      <div v-else>{{ title }}</div>

      <span class="action-button" @click="$emit('actionButtonClick')">
        <i v-if="showIcon" :class="icon"></i>
      </span>
    </header>
    <slot/>
  </div>
</template>

<script>
export default {
  name: "sidebar",
  props: {
    title: {
      type: String,
      required: true
    },
    url: {
      type: String,
      isRequired: true
    },
    icon: {
      type: String,
      default: 'far fa-plus-circle'
    },
    showIcon: Boolean
  }
}
</script>